import React, {useContext, useEffect, useState} from "react";
import {
    ErrorContainer,
    StyledLinkButton,
    StyledTitleBold,
    StyledTwoBoxWrapper,
    SuccessContainer
} from "../style/global.style";
import {
    CancelLeft,
    CancelLeftInner,
    CancelRight,
    StyledCancelPlan,
    StyledCardHorizontalContainer,
} from "./plans.style";


import Recommendation from "../commons/recommendation/recommendation.compoenent";
import FixelDataContext from "../../context/FixelDataContext";
import {formDataWithToken, wpUrl} from "../../services/globalService";
import LinkButton from "../linkButton/LinkButton.component";
import {useHistory} from "react-router-dom";

const AreYouSure = (props) => {

    const [plan,setPlan] = useState(null);
    const [error, setError] = useState(null);
    const [success,setSuccess] = useState(null);
    const history = useHistory();


    useEffect(()=> {
        setPlan(props.location.plan);
    },[props.location.plan])

    const { fullFixelData } = useContext(FixelDataContext);
    const currentPlan = fullFixelData?.plan?.stripe_sub_id;

    const cancelPlan = async (e) => {
        e.preventDefault();
        const cancelObj = {
            action: 'fxl_cancel_plan',
            sub_id: currentPlan,
            type: plan.name,
            plan_id: fullFixelData?.plan?.plan_id
        }
        try {
            const res = await formDataWithToken(wpUrl, cancelObj);
            if(res){
                setSuccess("Plan canceled");
                setTimeout(()=>{
                    history.push('/')
                },3000)
            }else {
                setError("There was a problem canceling your plan, please contact us at stores@fixel.ai or try again later");
            }
        } catch (e){
            setError("There was a problem canceling your plan, please contact us at stores@fixel.ai or try again later");
        }
    }
    return (
        <StyledCancelPlan>
            <StyledTwoBoxWrapper className={"mt-1"}>
                <CancelLeft>
                    <CancelLeftInner>
                        {error && <ErrorContainer className={'shake'}>{error}</ErrorContainer>}
                        {success && <SuccessContainer>{success}</SuccessContainer>}
                        <StyledTitleBold>
                            Are you sure?
                        </StyledTitleBold>
                        Cancelling your {plan.name} plan will <strong>disable your <br/> Fixel installation.</strong>
                        <br/>
                        <br/>
                        The existing audiences in your ad platforms will <br/> persist and will still be available for your <br/> campaign.
                        <br/><br/>
                        However, since they won't be updated, their <br/> performance is expected to deteriorate over<br/> time.

                        <StyledCardHorizontalContainer>
                            <StyledLinkButton onClick={() => history.push('/') }>
                                continue tracking
                            </StyledLinkButton>
                            <LinkButton alert={true} onClick={(event) => cancelPlan(event)}>cancel anyway</LinkButton>
                        </StyledCardHorizontalContainer>
                    </CancelLeftInner>
                </CancelLeft>
                <CancelRight>
                    <Recommendation/>
                </CancelRight>
            </StyledTwoBoxWrapper>
        </StyledCancelPlan>
    )
};
export default React.memo(AreYouSure);